// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__20R4g","item":"PaymentsMobile_item__1WO92","label":"PaymentsMobile_label__36WMy","amount":"PaymentsMobile_amount__12tgt"};